<div *ngIf="htmlMegaMenu" id="mega-menu" [innerHTML]="htmlMegaMenu"></div>
